import { PLUGINS } from './plugins';

export const COLOR = '#4F46E5';
export const LIGHT_COLOR = '#EEF2FF';
export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/helpnest-ai-chatbot-support-script`;
export const DEMO_URL = 'https://helpnest.xgenious.com/';
export const DOCS_URL = 'https://docs.xgenious.com/docs/helpnest-ai-based-support-chatbot-system/';
export const CODECANYON_URL = 'https://codecanyon.net/item/helpnest-ai-powered-chatbot-and-support-ticketing-system-saas/60825518';
export const REGULAR_PRICE = 59;
export const COMBO_PRICE = 89;
export const EXTENDED_PRICE = 199;
// Premium plugins are exclusive to the Everything Bundle + Exclusive License (see plugins.ts).
export const PREMIUM_PLUGIN_NAMES = PLUGINS.map((p) => p.name);
export const PREMIUM_PLUGIN_COUNT = PREMIUM_PLUGIN_NAMES.length;

// AI providers and OpenAI models supported by the platform.
// Source of truth: core/app/Enums/AiProvider.php + AiModelName.php.
export const AI_PROVIDER_LIST = 'OpenAI, DeepSeek, Google Gemini, GLM (Z.ai) and MiniMax';
export const OPENAI_MODEL_RANGE = 'GPT-6, GPT-4.1, o3/o4 and GPT-4o';

export const REVIEWS = [
  {
    name: 'vpanos',
    rating: 5,
    category: 'Regular License',
    body: "I couldn't be happier. The v1.4.0 update is exceptional — super fast, reliable. The support team is top-notch.",
  },
  {
    name: 'Diwio',
    rating: 5,
    category: 'Regular License',
    body: 'I initially faced some serious technical issues after the latest update. However, the support team was very patient, professional, and genuinely helpful throughout the entire process.',
  },
  {
    name: 'armgroup',
    rating: 5,
    category: 'Regular License',
    body: 'I had a bit of trouble during the initial setup, but once I contacted support they sorted everything out pretty quickly. Great product + great support.',
  },
];
